import React, { useState, useEffect } from 'react'
import { CFormLabel, CFormInput, CButton, CRow, CCol, CTable, CTableHead, CTableRow, CTableHeaderCell, CTableBody, CTableDataCell, CBadge, CFormTextarea, CNav, CNavItem, CNavLink, CTabContent, CTabPane, CCard, CCardBody } from '@coreui/react'
import { Plus, X } from 'lucide-react'
import GetDiagnosisData from './../../services/general/getDiagnosisData.api'
import Select from 'react-select'
import DiagnosisDetails from './DiagnosisDetails'
import ReasonSuggestion from './ReasonSuggestion'
import CloudinaryUploader from '../../components/shared/CloudinaryUploader'
import { SaveActivity } from './save-activity'

const ImagingDetails = ({ setImagingData, imagingData, allImgings, saveImagingFn, ButtonName, isEditing, selectedImaging, setIsEditing, setReasonList, reasonList, onClose, file, setFile }) => {
  const [name, setName] = useState('')
  const [priority, setPriority] = useState('')
  const [remarks, setRemarks] = useState('')
  const [keywords, setKeywords] = useState([])
  const [reason, setReason] = useState([])
  const [keywordInput, setKeywordInput] = useState('')
  const [diagnosisSelect, setDiagnosisSelect] = useState([])
  const [diagnosisData, setDiagnosisData] = useState([])
  const [imagingDetails, setImagingDetails] = useState([])
  const [editIndex, setEditIndex] = useState(null)
  const [activeTab, setActiveTab] = useState(0)
  const [imagingImage, setImagingImage] = useState(null)
  // const [file, setFile] = useState([]);

   const [reasonEntries, setReasonEntries] = useState([])
    const [codeEntries, setCodeEntries] = useState([])
    const [reasonInput, setReasonInput] = useState('')
    const [codeInput, setCodeInput] = useState('')

   const addReasonEntry = () => {
      const trimmed = reasonInput.trim()
      if (!trimmed) return
      setReasonEntries((prev) => [...prev, trimmed])
      setReasonInput('')
    }
  
    const addCodeEntry = () => {
      const trimmed = codeInput.trim()
      if (!trimmed) return
      setCodeEntries((prev) => [...prev, trimmed])
      setCodeInput('')
    }



  const addNewDiagnosis = () => {
    setReasonList((prevList) => {
      const updatedList = Array.isArray(prevList) ? prevList : []
      return [...updatedList, { diagnosis: '', reason: '' }]
    })
  }
  const handleDiagnosisChange = (index, selectedDiagnosis) => {
    const updatedList = [...reasonList]
    updatedList[index].diagnosis = selectedDiagnosis
    setReasonList(updatedList)
  }

  const handleReasonChange = (index, newReason) => {
    const updatedList = [...reasonList]
    updatedList[index].reason = newReason
    setReasonList(updatedList)
  }

  const getData = async () => {
    let a = await GetDiagnosisData()
    let data = JSON.parse(a.d)
    const allDiagnosis = data.Data.map((item) => ({
      value: item.id,
      label: item.Name.trim(),
    }))
    setDiagnosisData(allDiagnosis)
  }
  useEffect(() => {
    getData()
  }, [])

 useEffect(() => {
  if (isEditing && selectedImaging) {
    setName(selectedImaging.Name || "");
    setPriority(selectedImaging.Priority || "");

    // Keywords
    let parsed = [];

    try {
      if (Array.isArray(selectedImaging.Keywords)) {
        parsed = selectedImaging.Keywords;
      } else if (typeof selectedImaging.Keywords === "string") {
        parsed = JSON.parse(selectedImaging.Keywords);

        if (typeof parsed === "string") {
          parsed = JSON.parse(parsed);
        }
      }

      if (!Array.isArray(parsed)) parsed = [];
    } catch {
      parsed = [];
    }

    setImagingDetails(parsed);

    // Imaging Reason
    try {
      const reasons =
        typeof selectedImaging.ImagingReason === "string"
          ? JSON.parse(selectedImaging.ImagingReason)
          : [];

      setReasonEntries(Array.isArray(reasons) ? reasons : []);
    } catch {
      setReasonEntries([]);
    }

    // Imaging Code
    // try {
    //   const codes =
    //     typeof selectedImaging.ImagingCode === "string"
    //       ? JSON.parse(selectedImaging.ImagingCode)
    //       : [];

    //   setCodeEntries(Array.isArray(codes) ? codes : []);
    // } catch {
    //   setCodeEntries([]);
    // }
  }
}, [isEditing, selectedImaging]);
  // const handleSave = () => {
  //     const newDetail = {
  //         remarks,
  //         keyword: keywords.join(','),
  //         diagnosis: diagnosisSelect.map(d => d.value).join(','),
  //     };
  //     setImagingDetails([...imagingDetails, newDetail]);
  //     setRemarks('');
  //     setKeywords([]);
  //     setKeywordInput('');
  //     setDiagnosisSelect([]);
  // };

  const handleKeywordImagingRemarkEdit = (index) => {
    const detail = imagingDetails[index]
    setRemarks(detail.remarks)
    setKeywords(detail.keyword.split(',').filter((item) => item !== ''))
    setDiagnosisSelect(
      detail.diagnosis.split(',').map((id) => {
        const diagnosisItem = diagnosisData.find((item) => item.value === parseInt(id.trim()))
        return diagnosisItem || { value: id, label: id }
      }),
    )
    setEditIndex(index)

    try {
  const reasons =
    typeof selectedImaging.ImagingReason === "string"
      ? JSON.parse(selectedImaging.ImagingReason)
      : [];

  setReasonEntries(Array.isArray(reasons) ? reasons : []);
} catch {
  setReasonEntries([]);
}

// try {
//   const codes =
//     typeof selectedImaging.ImagingCode === "string"
//       ? JSON.parse(selectedImaging.ImagingCode)
//       : [];

//   setCodeEntries(Array.isArray(codes) ? codes : []);
// } catch {
//   setCodeEntries([]);
// }
  }

  const handleDeleteImaginngsDetails = (index) => {
    const updatedDetails = imagingDetails.filter((_, i) => i !== index)
    setImagingDetails(updatedDetails)
  }

  const handleSave = () => {
    const newDetail = {
      remarks,
      keyword: keywords.join(','),
      diagnosis: diagnosisSelect.map((d) => d.value).join(','),
      reasonList: reasonList,
    }
    if (editIndex !== null) {
      const updatedDetails = imagingDetails.map((detail, index) => (index === editIndex ? newDetail : detail))
      setImagingDetails(updatedDetails)
      setEditIndex(null)
    } else {
      setImagingDetails([...imagingDetails, newDetail])
    }
    setRemarks('')
    setKeywords([])
    setReasonList([{ diagnosis: '', reason: '' }])
    setKeywordInput('')
    setDiagnosisSelect([])
  }

  const handleAddKeyword = (event) => {
    if (event.key === 'Enter' && keywordInput.trim() !== '') {
      event.preventDefault()
      setKeywords([...keywords, keywordInput.trim()])
      setKeywordInput('')
    }
  }

  const handleRemoveKeyword = (index) => {
    const newKeywords = keywords.filter((_, i) => i !== index)
    setKeywords(newKeywords)
  }

  const handleAdd = async () => {
    setIsEditing(false)
    const formattedJsonString = JSON.stringify(reasonList)
    const updatedData = {
      name,
      priority: Number(allImgings[allImgings.length - 1].Priority) + 1,
      Keywords: JSON.stringify(imagingDetails),ImagingReason: JSON.stringify(reasonEntries),
      ImagingCode:''
    }
    await saveImagingFn({ name: updatedData.name, priority: updatedData.priority, Keywords: JSON.stringify(updatedData.Keywords), ImagingReason: updatedData.ImagingReason,
   ImagingCode: '' }, false, formattedJsonString, file)
    // localStorage.setItem('imagings', JSON.stringify(existingData));
    setImagingData((p) => [...p, { Name: name, priority, Keywords: updatedData }])

    setRemarks('')
    setName('')
    setPriority('')
    setKeywords([])
    setReasonList([{ diagnosis: '', reason: '' }])
    setKeywordInput('')
    setDiagnosisSelect([])
    setImagingDetails([])
    setFile([])
  }

  const handleAddToTableCreated = async () => {
    const formattedJsonString = JSON.stringify(reasonList)
    if (isEditing) {
      const updatedData = {
        name,
        priority,
        Keywords: JSON.stringify(imagingDetails),
        ImagingReason: JSON.stringify(reasonEntries),
    ImagingCode: ''
      }
      await saveImagingFn(
  {
    ID: selectedImaging?.ID,
    name: updatedData.name,
    priority: updatedData.priority,
    Keywords: JSON.stringify(updatedData.Keywords),
    ImagingReason: updatedData.ImagingReason,
    ImagingCode: ''
  },
  false,
  formattedJsonString,
  file
)
      SaveActivity('Updated Imaging Details')
    } else {
      const updatedData = {
        name,
        priority,
        Keywords: JSON.stringify(imagingDetails),
         ImagingReason: JSON.stringify(reasonEntries),
  ImagingCode: ''
      }
      await saveImagingFn(
  {
    ID: selectedImaging?.ID,
    name: updatedData.name,
    priority: updatedData.priority,
    Keywords: JSON.stringify(updatedData.Keywords),
    ImagingReason: updatedData.ImagingReason,
    ImagingCode: ''
  },
  false,
  formattedJsonString,
  file
)
      // localStorage.setItem('imagings', JSON.stringify(existingData));
      setImagingData((p) => [...p, { Name: name, priority, Keywords: updatedData }])
      SaveActivity('Added Imaging Details')
    }
    setRemarks('')
    setName('')
    setPriority('')
    setKeywords([])
    setReasonList([{ diagnosis: '', reason: '' }])
    setKeywordInput('')
    setDiagnosisSelect([])
    setImagingDetails([])
    setFile([])
  }

  const removeDiagnosis = (indexToRemove) => {
    setReasonList((prevDiagnosisList) => prevDiagnosisList.filter((_, index) => index !== indexToRemove))
  }

  const handleDeleteFile = (id) => {
    setFile((prevFiles) => {
      if (prevFiles.length === 1) return []
      return prevFiles.filter((item, i) => item.id !== id)
    })
  }

  const handleCloudinaryUpload = (url, type, fileName, id, publicId) => {
    setFile((prevFiles) => {
      const isDuplicate = prevFiles.some((file) => file.url === url)

      if (isDuplicate) return prevFiles

      return [...prevFiles, { url, type, fileName, id, publicId }]
    })
  }

  return (
    <>
      <div className="imaging-theme__details">
        <form>
          <div className="pe-tab-underline-nav mb-4">
            <CNav role="tablist" className="justify-content-center">
              <CNavItem>
                <CNavLink active={activeTab === 0} onClick={() => setActiveTab(0)}>
                  Details
                </CNavLink>
              </CNavItem>

              {/* <CNavItem>
                              <CNavLink active={activeTab === 1} onClick={() => setActiveTab(1)}>
                                  Order
                              </CNavLink>
                          </CNavItem> */}
              <CNavItem>
                <CNavLink active={activeTab === 2} onClick={() => setActiveTab(2)}>
                  Image
                </CNavLink>
              </CNavItem>
            </CNav>
          </div>

          <CTabContent activeTab={activeTab}>
            <CTabPane visible={activeTab === 0}>
              <CRow>
                <CCol xs={6}>
                  <div className="mb-3">
                    <CFormLabel htmlFor="name">Name</CFormLabel>
                    <CFormInput id="name" value={name} onChange={(e) => setName(e.target.value)} />
                  </div>
                </CCol>
                <CCol xs={6}>
                  <div className="mb-3">
                    <CFormLabel htmlFor="priority">Priority</CFormLabel>
                    <CFormInput id="priority" value={priority} onChange={(e) => setPriority(e.target.value)} />
                  </div>
                </CCol>
              </CRow>


<CCol md={12}>
                <hr />
              </CCol>
    {/* Reason */}
<CRow className="mb-3">
  <CCol xs="12">
    <div className="d-flex align-items-end gap-3">
      <div className="flex-grow-1">
        <CFormLabel>Reason</CFormLabel>
        <CFormInput
          type="text"
          placeholder="Enter reason"
          value={reasonInput}
          onChange={(e) => setReasonInput(e.target.value)}
        />
      </div>

        <div
  className="d-flex align-items-center justify-content-center"
  style={{
    width: '42px',
    height: '38px',
    cursor: 'pointer',   
    border: '1px solid rgb(201 201 201)',
    borderRadius: '0.375rem',
    background: 'transparent',
  }}
  onClick={addReasonEntry}
>
  <Plus
    className="imaging-theme__plus-icon"
    strokeWidth={2}
    size={24}
  />
</div>
    </div>
  </CCol>
</CRow>

{/* Added Reasons */}
{reasonEntries.length > 0 && (
  <CRow className="mb-3">
    <CCol xs="12">
      <CFormLabel>Added Reasons</CFormLabel>

      <div
        className="form-control d-flex flex-wrap align-items-center gap-2 imaging-theme__chip-group"
      >
        {reasonEntries.map((reason, index) => (
          <span
            key={index}
            className="d-flex align-items-center imaging-theme__chip imaging-theme__chip--reason"
          >
            <span className="imaging-theme__chip-label">{reason}</span>

            <button
              type="button"
              className="imaging-theme__chip-close ms-2"
              onClick={() => removeReasonEntry(index)}
              aria-label="Remove reason"
            >
              <X size={14} strokeWidth={2.5} />
            </button>
          </span>
        ))}
      </div>
    </CCol>
  </CRow>
)}
{/* Code */}
{/* <CRow className="mb-3">
  <CCol xs="12">
    <div className="d-flex align-items-end gap-3">
      <div className="flex-grow-1">
        <CFormLabel>Code</CFormLabel>
        <CFormInput
          type="text"
          placeholder="Enter code"
          value={codeInput}
          onChange={(e) => setCodeInput(e.target.value)}
        />
      </div>
     <div
  className="d-flex align-items-center justify-content-center"
  style={{
    width: '42px',
    height: '38px',
    cursor: 'pointer',   
    border: '1px solid rgb(201 201 201)',
    borderRadius: '0.375rem',
    background: 'transparent',
  }}
  onClick={addCodeEntry}
>
  <Plus
    className="imaging-theme__plus-icon"
    strokeWidth={2}
    size={24}
  />
</div>

      {/* <CButton className="d-flex align-items-center" color="primary" size="sm" onClick={addCodeEntry}>
        +        
      </CButton> */}
    {/* </div>
  </CCol>
</CRow> */} 

{/* Added Codes */}
{/* {codeEntries.length > 0 && (
  <CRow className="mb-3">
    <CCol xs="12">
      <CFormLabel>Added Codes</CFormLabel>

      <div
        className="form-control d-flex flex-wrap align-items-center gap-2 imaging-theme__chip-group"
      >
        {codeEntries.map((code, index) => (
          <span
            key={index}
            className="d-flex align-items-center imaging-theme__chip imaging-theme__chip--code"
          >
            <span className="imaging-theme__chip-label">{code}</span>

            <button
              type="button"
              className="imaging-theme__chip-close ms-2"
              onClick={() => removeCodeEntry(index)}
              aria-label="Remove code"
            >
              <X size={14} strokeWidth={2.5} />
            </button>
          </span>
        ))}
      </div>
    </CCol>
  </CRow>
)} */}


              <h6>Imaging Details</h6>
              <hr />
              <CRow>
                <CCol xs={6}>
                  <DiagnosisDetails setKeywords={setKeywords} keywords={keywords} />
                  {/* <CustomKeywordSeperator state={keywords} setState={setKeywords} /> */}
                </CCol>
               <CCol xs={6}>
  <CFormLabel htmlFor="diagnosis">Select Diagnosis</CFormLabel>

  <Select
    id="diagnosis"
    className="z-index-3 basic-multi-select ui-react-select"
    classNamePrefix="select"
    value={diagnosisSelect}
    options={diagnosisData}
    onChange={setDiagnosisSelect}
    isMulti
    placeholder="Select Diagnosis..."
    closeMenuOnSelect={false}
    hideSelectedOptions={false}
    controlShouldRenderValue={true}
    styles={{
      multiValue: (base) => ({
        ...base,
        display: 'none',
      }),
      valueContainer: (base) => ({
        ...base,
        flexWrap: 'nowrap',
        overflow: 'hidden',
      }),
      input: (base) => ({
        ...base,
        margin: 0,
        padding: 0,
      }),
    }}
    components={{
      MultiValue: ({ index, getValue, data }) => {
        const selected = getValue()
        const isLast = index === selected.length - 1

        return (
          <span>
            {data.label}
            {!isLast && ', '}
          </span>
        )
      },
    }}
  />
</CCol>
                {/* <CCol xs={4}>
                            <DiagnosisDetails label={"Reason"} keywords={reason} setKeywords={setReason} />
                        </CCol> */}
              </CRow>

              <div className="mb-3 w-100">
                <CFormLabel htmlFor="remarks">Remarks</CFormLabel>
                <CFormTextarea
                  id="remarks"
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                  placeholder="Enter the remarks.."
                  rows={3} // You can adjust the number of rows as needed
                />
              </div>
              <div className="text-right">
                <div className="text-right">
                  <CButton className="imaging-theme__primary-btn" color="primary" onClick={handleSave}>
                    {editIndex !== null ? 'Update Imaging' : 'Add Imaging'}
                  </CButton>
                </div>
                {/* <CButton color="primary" onClick={handleSave}>{'Add Imaging'}</CButton> */}
              </div>
            </CTabPane>
            <CTabPane visible={activeTab === 1}>
              <CRow>
                <CCol className="d-flex justify-content-center" style={{ marginTop: '-40px' }}>
                  <div className="w-75 px-3">
                    <CCard className="imaging-theme__reason-toolbar" style={{ border: 'none' }}>
                      <CCardBody className="  ">
                        <CButton className="imaging-theme__primary-btn" color="primary" onClick={addNewDiagnosis}>
                          + Add Reason
                        </CButton>
                      </CCardBody>
                    </CCard>

                    <div className="overflow-auto  mx-auto   px-3" style={{ height: '400px' }}>
                      {reasonList &&
                        reasonList?.map((item, index) => (
                          <div
                            key={index}
                            className="p-3 border rounded imaging-theme__reason-card my-3 position-relative"
                            style={{
                              borderLeft: '5px solid #007bff',
                              borderRadius: '8px',
                              boxShadow: '0 4px 12px rgba(0, 123, 255, 0.1)',
                            }}
                          >
                            <div className="d-flex justify-content-end align-items-center mb-2">
                              <CButton variant="outline" color="danger" size="sm" onClick={() => removeDiagnosis(index)} className="position-absolute top-0 end-0 m-2" style={{ boxShadow: 'none' }}>
                                <X size={18} strokeWidth={2.5} />
                              </CButton>
                            </div>

                            <CFormLabel className="  fw-bold">Select Diagnosis</CFormLabel>
                            <Select
                              isMulti
                              className="basic-multi-select ui-react-select"
                              placeholder="Select Diagnosis"
                              options={diagnosisData}
                              value={item.diagnosis}
                              onChange={(selectedOption) => handleDiagnosisChange(index, selectedOption)}
                              classNamePrefix="select"
                              styles={{
                                control: (base) => ({
                                  ...base,
                                  // borderColor: '#007bff',
                                  boxShadow: 'none',
                                }),
                              }}
                            />

                            <div className="mt-4">
                              <ReasonSuggestion label={`Reason for Diagnosis`} keywords={item.reason} setKeywords={(newReason) => handleReasonChange(index, newReason)} />
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                </CCol>
              </CRow>
            </CTabPane>
            <CTabPane visible={activeTab === 2}>
              <div className="d-flex   gap-2  mt-3 mx-5">
                <CloudinaryUploader filesAl={imagingImage && imagingImage.length > 0 ? imagingImage : file} onDelete={handleDeleteFile} onUploadSuccess={handleCloudinaryUpload} showStyleButton={true} />
                <div className="d-flex flex-wrap gap-3">
                  {/* {Array.isArray(file) &&
                    file.map((fileItem, fileIdx) => { */}

                  {Array.isArray(file) &&
                    file.map((fileItem, fileIdx) => {
                      //   const fileUrl = file.uploaded ? file.url : file.preview || file.url
                      //   const fileType = file.type || ''
                      //   const extension = fileUrl.split('.').pop().toLowerCase()

                      const fileUrl = fileItem.uploaded ? fileItem.url : fileItem.preview || fileItem.url
                      const fileType = fileItem.type || ''
                      const extension = fileUrl ? fileUrl.split('.').pop().toLowerCase() : ''

                      return (
                        <div key={fileIdx} className="d-flex flex-column align-items-center text-center">
                          {fileType === 'image' ? (
                            <div
                              style={{
                                position: 'relative',
                                width: '80px',
                                height: '80px',
                                borderRadius: '4px',
                                overflow: 'hidden',
                              }}
                              className="shadow border"
                            >
                              <img
                                src={fileUrl}
                                alt={file.fileName || 'Preview'}
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'cover',
                                }}
                              />

                              <div
                                style={{
                                  position: 'absolute',
                                  top: '4px',
                                  right: '4px',
                                  display: 'flex',
                                  gap: '6px',
                                  backgroundColor: 'rgba(255, 255, 255, 0.7)',
                                  borderRadius: '4px',
                                  padding: '2px',
                                }}
                              >
                                {/* <Pencil
                                                                             className="cursor-pointer text-primary"
                                                                             size={15}
                                                                             onClick={() => handleEditFileData(entry.id)}
                                                                           />
                                                    <Trash
                                                                             className="cursor-pointer text-danger"
                                                                             size={15}
                                                                             onClick={() => handleDeleteFileData(entry.id)}
                                                                             style ={{cursor: "pointer"}}
                                                                           /> */}
                              </div>
                            </div>
                          ) : fileType === 'video' || ['mp4', 'webm', 'ogg'].includes(extension) ? (
                            <div
                              style={{
                                position: 'relative',
                                width: '80px',
                                height: '80px',
                                borderRadius: '4px',
                                overflow: 'hidden',
                                pointer: 'cursor',
                              }}
                              className="shadow border"
                            >
                              {/* Video */}
                              <video
                                src={fileUrl}
                                controls
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'cover',
                                }}
                              />

                              {/* Action buttons */}
                              <div
                                style={{
                                  position: 'absolute',
                                  top: '4px',
                                  right: '4px',
                                  display: 'flex',
                                  gap: '6px',
                                  backgroundColor: 'rgba(255, 255, 255, 0.7)',
                                  borderRadius: '4px',
                                  padding: '2px',
                                }}
                              >
                                {/* <Pencil
                                                                               className="cursor-pointer text-primary"
                                                                               size={15}
                                                                               onClick={() => handleEditFileData(entry.id)}
                                                                             />
                                                    <Trash
                                                                               className="cursor-pointer text-danger"
                                                                               size={15}
                                                                               onClick={() => handleDeleteFileData(entry.id)}
                                                                               style={{ cursor: "pointer" }}
                                                                             /> */}
                              </div>
                            </div>
                          ) : ['pdf', 'doc', 'docx'].includes(extension) ? (
                            <div
                              style={{
                                position: 'relative',
                                width: '80px',
                                height: '80px',
                                borderRadius: '4px',
                                overflow: 'hidden',
                                background: '#f8f9fa',
                              }}
                              className="d-flex align-items-center justify-content-center border shadow"
                            >
                              {/* File Icon & Extension */}
                              <a
                                href={fileUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  textDecoration: 'none',
                                  color: 'inherit',
                                }}
                                className="d-flex align-items-center justify-content-center flex-column"
                              >
                                <i className="bi bi-file-earmark-text" style={{ fontSize: '24px' }}></i>
                                <p className="small m-0">{extension.toUpperCase()}</p>
                              </a>

                              {/* Action buttons */}
                              <div
                                style={{
                                  position: 'absolute',
                                  top: '4px',
                                  right: '4px',
                                  display: 'flex',
                                  gap: '6px',
                                  backgroundColor: 'rgba(255, 255, 255, 0.7)',
                                  borderRadius: '4px',
                                  padding: '2px',
                                }}
                              >
                                {/* <Pencil
                                                                                 className="cursor-pointer text-primary"
                                                                                 size={15}
                                                                                 onClick={() => handleEditFileData(entry.id)}
                                                                               />
                                                    <Trash
                                                                                 className="cursor-pointer text-danger"
                                                                                 size={15}
                                                                                 onClick={() => handleDeleteFileData(entry.id)}
                                                                                 style={{ cursor: "delete"}}
                                                                               /> */}
                              </div>
                            </div>
                          ) : (
                            <a
                              href={fileUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                width: '100px',
                                height: '100px',
                                borderRadius: '4px',
                                background: '#e0e0e0',
                              }}
                              className="d-flex align-items-center justify-content-center border"
                            >
                              <div>
                                <i className="bi bi-file-earmark" style={{ fontSize: '24px' }}></i>
                                <p className="small m-0">File</p>
                              </div>
                            </a>
                          )}
                          <div
                            style={{
                              width: '100px',
                              height: '20px',
                              overflow: 'auto',
                              marginTop: '5px',
                            }}
                          >
                            <a
                              href={fileItem.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-dark"
                              style={{
                                display: 'inline-block',
                                padding: '2px 5px',
                                backgroundColor: '#f0f0f0',
                                borderRadius: '4px',
                                fontSize: '0.75rem',
                                fontWeight: 'bold',
                                textDecoration: 'none',
                                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                transition: 'background-color 0.3s ease',
                              }}
                              onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#e0e0e0')}
                              onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#f0f0f0')}
                            >
                              {/* {file.fileName || 'File'} */}
                              {fileItem.fileName || 'File'}
                            </a>
                          </div>
                          {/* <small className="mt-1 text-truncate" style={{ maxWidth: "100px" }}>
                                                    {file.fileName}
                                                </small> */}
                        </div>
                      )
                    })}
                </div>
              </div>
            </CTabPane>
          </CTabContent>
        </form>
        {activeTab === 0 && imagingDetails.length > 0 && (
          <div>
            {' '}
            <hr />
            <div className="  w-100 rounded overflow-auto my-2 border" style={{ maxHeight: '400px' }}>
              {imagingDetails.length > 0 && (
                <table className="table table-bordered table-striped table-hover ">
                  <thead className="table-primary  ">
                    <tr>
                      <th scope="col" style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                        Diagnosis
                      </th>
                      <th scope="col" style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                        Keywords
                      </th>
                      <th scope="col" style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                        Remarks
                      </th>
                      <th scope="col" style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {imagingDetails.map((detail, index) => (
                      <tr key={index}>
                        <td>
                          {String(detail.diagnosis || '')
                            .split(',')
                            .map((diagnosis) => diagnosis.trim())
                            .filter(Boolean).length > 0 && (
                            <span className="badge bg-info p-1">
                              {String(detail.diagnosis || '')
                                .split(',')
                                .map((diagnosis) => diagnosis.trim())
                                .filter(Boolean)
                                .map((diagnosis, diagnosisIndex) => {
                                  const diagnosisItem = diagnosisData.find((items) => items.value === parseInt(diagnosis))

                                  return (
                                    <span key={diagnosisIndex} className="me-1">
                                      {diagnosisItem ? diagnosisItem.label : diagnosis}
                                    </span>
                                  )
                                })}
                            </span>
                          )}
                        </td>                       
                    <td style={{ padding: '6px 8px', verticalAlign: 'middle' }}>
  <div
    style={{
      whiteSpace: 'pre-wrap',
      overflowWrap: 'anywhere',
      textAlign: 'left',
      margin: 0,
      padding: 0,
    }}
  >
    {detail.keyword}
  </div>
</td>
                       
                        <td>{detail.remarks}</td>
                        <td>
                          <div className="d-flex align-items-center gap-2">
                            <button type="button" className="btn btn-outline-warning btn-sm d-flex align-items-center" onClick={() => handleKeywordImagingRemarkEdit(index)}>
                              <i className="bi bi-pencil-fill me-1"></i>Edit
                            </button>
                            <button type="button" className="btn btn-outline-danger btn-sm d-flex align-items-center" onClick={() => handleDeleteImaginngsDetails(index)}>
                              <i className="bi bi-trash-fill me-1"></i>Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        )}
        <div className="text-right d-flex justify-content-end align-items-center gap-2 flex-wrap">
          <CButton
            color="secondary"
            className="ui-action-btn ui-action-btn--secondary"
            onClick={() => {
              ;(onClose(false), setFile([]))
            }}
          >
            Close
          </CButton>
          {isEditing && (
            <CButton variant="outline" color="success" onClick={handleAdd}>
              Save as New Imaging
            </CButton>
          )}
          <CButton className="ui-action-btn ui-action-btn--primary" color="primary" onClick={handleAddToTableCreated}>
            {ButtonName}
          </CButton>
        </div>
      </div>
    </>
  )
}

export default ImagingDetails
